// initializes JS logic for user cards (rails view components)
// `app/components/user/user_cards`
// `app/assets/stylesheets/components/_user-cards.scss`
import { ResumeUserCard } from './resume-user-card';

ResumeUserCard.init();
